import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Heart, MessageCircle, ArrowRight } from "lucide-react";
import { instagramPosts, instagramHandle, socialLinks } from "../mock";
import { useI18n } from "../i18n/I18nContext";

const InstagramFeed = () => {
  const { t } = useI18n();

  return (
    <section className="bg-slate-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-700 uppercase tracking-widest text-[#0a6ed1]">
              <Instagram className="w-5 h-5" /> {t("instaEyebrow")}
            </span>
            <h2 className="font-display font-800 text-3xl md:text-4xl text-[#0a2540] mt-2">
              {t("instaTitle")}
            </h2>
            <p className="mt-3 text-slate-500 text-lg max-w-xl">{t("instaBody")}</p>
          </div>
          <a
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#0a2540] hover:bg-[#16355c] text-white font-600 px-6 py-3 rounded-full transition-colors self-start"
          >
            {t("followUs")} {instagramHandle} <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="mb-8">
          <Link to="/studio" className="inline-flex items-center gap-2 text-[#0a6ed1] font-600 link-underline">
            Browse our 100 ready-to-post designs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {instagramPosts.map((post) => (
            <a
              key={post.id}
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square overflow-hidden rounded-lg bg-slate-200"
            >
              <img
                src={post.image}
                alt={post.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#0a2540]/0 group-hover:bg-[#0a2540]/70 transition-colors duration-300 flex flex-col items-center justify-center gap-3 p-3 text-white opacity-0 group-hover:opacity-100">
                <Instagram className="w-6 h-6" />
                <div className="flex items-center gap-4 text-sm font-600">
                  <span className="flex items-center gap-1.5">
                    <Heart className="w-4 h-4" /> {post.likes}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <MessageCircle className="w-4 h-4" /> {post.comments}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
